module.exports = __webpack_public_path__ + "media/images/logos/la-fitness-logo-667142611c422679ea4d67ed6b795e10.svg";